const GRADE_ACCENT_COLORS: Record<number, string> = {
  1: "#22c55e",
  2: "#047857",
  3: "#eab308",
  4: "#f97316",
  5: "#ef4444",
  6: "#18181b",
};

export const gradeAccentColor = (grade: number) => GRADE_ACCENT_COLORS[grade] || GRADE_ACCENT_COLORS[2];
